import { useQuery } from '@tanstack/react-query';

import type { APMAsset } from '@cognite/apm-client';
import type { Filters } from '@cognite/fdm-client';

import { useFDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../../utils/queryKeys';

type Props = {
  externalIds?: string[];
  spaces?: string[];
};

export const useAPMAssetsQuery = ({ externalIds, spaces }: Props) => {
  const { assetService } = useFDMServices();

  return useQuery<APMAsset[] | undefined>({
    queryKey: [QueryKeys.APM_ASSET_LIST, externalIds],
    queryFn: async () => {
      if (externalIds === undefined || externalIds.length === 0) {
        return;
      }
      const filters: Filters = {
        in: {
          property: 'externalId',
          in: externalIds,
        },
      };
      return assetService.listAPMAssets(filters, undefined, undefined, spaces);
    },
    meta: { error: { captureError: true } },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Boolean(externalIds && externalIds[0]),
  });
};
